import { ReactElement, useState, useCallback, useEffect, useMemo } from 'react';

import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
  Button,
  GoBackButton,
  InputSearch,
  Pagination,
  Table,
} from '~/components';
import { ISearch } from '~/components/Pagination/Search';
import { useLoading } from '~/hooks/loading';
import { IPagination, PageOptionsRequest } from '~/models/Common';
import { IMethod } from '~/models/Method';
import { MethodService } from '~/services';

import * as S from './styles';

function Methods(): ReactElement {
  const { setLoading } = useLoading();
  // const [methods, setMethods] = useState<IPagination<IMethod[]>>({
  //   data: [],
  //   lastPage: 0,
  //   page: 1,
  //   perPage: 1,
  //   total: '0',
  // });
  const [methods, setMethods] = useState<IMethod[]>([]);
  const [searchFilter, setSearchFilter] = useState('');
  const [pageOptions, setPageOptions] = useState<PageOptionsRequest>({
    page: 1,
  });
  const router = useHistory();

  const handleNavitageToMethodCadaster = useCallback(() => {
    router.push('/ilab/methods/cadaster');
  }, [router]);

  const handleNavigateToMethodDetails = useCallback(
    (methodId: number) => {
      router.push(`/ilab/methods/details/${methodId}`);
    },
    [router],
  );

  const handleGetMethods = async (search: ISearch) => {
    try {
      setLoading(true);

      const { data } = await MethodService.getAllMethods(search);
      setMethods(
        data.sort(function (a, b) {
          if (a.tranning_method < b.tranning_method) {
            return -1;
          }
          if (a.tranning_method > b.tranning_method) {
            return 1;
          }
          return 0;
        }),
      );

      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Ocorreu um problema ao requisitar dados do servidor!');
    }
  };

  useEffect(() => {
    handleGetMethods({
      searchFilter,
      page: pageOptions.page,
      perpage: 999999999,
    });
  }, [searchFilter, pageOptions]);

  const MethodsTableMemo = useMemo(
    () => (
      <Table
        colsNames={[
          'Método',
          'Execução',
          'Princípio ativo',
          'Tempo de descanso',
          'Tempo total',
          '',
        ]}
      >
        {methods?.map((method) => (
          <tr
            key={method.id}
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onClick={() => handleNavigateToMethodDetails(method.id!)}
          >
            <td>{method.tranning_method}</td>
            <td>{method.execution}</td>
            <td>{method.method_principle}</td>
            <td>{method.interval_recovery_total?.concat(' minuto(s)')}</td>
            <td>{method.total_time?.concat(' minuto(s)')}</td>
            <td>{'>'}</td>
          </tr>
        ))}
      </Table>
    ),
    [handleNavigateToMethodDetails, methods],
  );

  console.log('methods:', methods);

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.Header>
          <S.Title>Listagem de Métodos</S.Title>
          <InputSearch
            name="search"
            onSearch={(value) => setSearchFilter(value)}
            placeholder="Buscar por nome do método"
          />
        </S.Header>
        {MethodsTableMemo}
        <S.Footer>
          <Button
            textContent="Cadastrar"
            onClick={handleNavitageToMethodCadaster}
            size="small"
            variant="yellow"
            extraStyles={{
              maxWidth: 300,
            }}
          />
          {/* <Pagination
            pageCount={methods.lastPage!}
            pageRangeDisplayed={3}
            {...{ setPageOptions }}
          /> */}
        </S.Footer>
      </S.Container>
    </>
  );
}

export default Methods;
